
export default {
  props: {
    article: {
      type: Object,
      default: () => ({})
    }
  }
}
